var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print-foot"},[_c('div',{staticClass:"foot-top"},[_vm._v(" 注：以上货物请校对数里，请确认无误后签字，如有质里问题，请在收货3天内通知本公司，感谢您的支持与配合! ")]),_c('div',{staticClass:"foot-bottom"},[_c('span',{staticClass:"flex-1"},[_vm._v("送货单位及经手人：")]),_c('span',{staticClass:"flex-1"},[_vm._v("收货单位及经手人：")])])])
}]

export { render, staticRenderFns }